import { render, staticRenderFns } from "./PartnerSpare.vue?vue&type=template&id=725cad40&scoped=true"
import script from "./PartnerSpare.vue?vue&type=script&lang=js"
export * from "./PartnerSpare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725cad40",
  null
  
)

export default component.exports